module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "menu"
    }
  }, [_c('div', [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_vm._m(1), _vm._m(2), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://form.jotform.com/241063912551652"
    }
  }, [_vm._v("https://form.jotform.com/241063912551652")]), _c('p'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p'), _vm._m(5), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('manual_mis_sesc.pdf')
      }
    }
  }, [_vm._v("Acessar Manual")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('descontados-mes.pdf')
      }
    }
  }, [_vm._v("Acessar lista")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Voltar",
      "icone": "voltar"
    },
    on: {
      "clicado": function($event) {
        return _vm.volta()
      }
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modalSescLabel"
    }
  }, [_vm._v("\n            Credenciamento Prefeitura de Santos - SESC\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                Olá!"), _c('br'), _c('br'), _vm._v("\n\n                Esta ação de Credenciamento do Sesc é exclusiva para os servidores ativos\n                Municipal de Santos e ficará disponível para preenchimento a partir das\n                10h30 do 1º dia útil do mês (exceto segundas-feiras), por 48 horas, ou até\n                atingir o limite permitido no contrato, a saber, 300 inscrições/mês.\n                "), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Para acessar o link do formulário, faz-se necessário “atualizar os dados de\n                  navegação”,")]), _vm._v("\n                limpando o histórico de seu navegador, preferindo computadores ou notebook.\n                "), _c('br'), _c('br'), _vm._v("\n                Após o período de preenchimento, os dados serão validados pela Prefeitura Municipal de Santos,\n                a qual procederá com "), _c('strong', [_vm._v("desconto único anual")]), _vm._v(" na folha de pagamento no valor\n                de R$40,00 (quarenta reais), referente ao credenciamento do titular.\n                "), _c('br'), _c('br'), _vm._v("\n                Para ativar sua credencial MIS digital, você receberá um SMS recomendando a instalação do\n                aplicativo “Credencial Sesc SP” (iOS ou Android). Desta forma é OBRIGATÓRIO informar seu\n                número de celular e aceitar o recebimento de SMS durante o preenchimento deste formulário.\n                Lembramos que a credencial MIS tem validade de 1 (um) ano, com abrangência no estado de\n                São Paulo e não cria vínculo com o Sesc, assim como não concede os mesmos benefícios\n                oferecidos aos trabalhadores do Comércio de Bens, Serviços e Turismo.\n                "), _c('br'), _c('br'), _vm._v("Para iniciarmos o processo de credenciamento MIS, tenha em\n                mãos seus documentos pessoais (RG, CPF e uma foto).\n\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('br'), _vm._v("\n                Importante! "), _c('br'), _c('br'), _vm._v("\n                O não preenchimento dos dados, assim como o preenchimento incompleto,\n                serão considerados como inconsistência cadastral.\n                "), _c('br'), _vm._v("\n                Caso o limite de 300 (trezentas) inscrições/mês seja alcançado no prazo de 48 horas, o servidor\n                deverá aguardar o próximo período para inscrever-se novamente, por não haver lista de espera.\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Link do formulário eletrônico de inscrição para credenciamento dos servidores da\n                  Prefeitura Municipal de Santos:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Acesso:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Manual para cadastramento no sistema do SESC, contendo perguntas e respostas\n                  frequentes:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("\n                  Lista contendo Nome e Registro dos servidores contemplados no último mês (os quais\n                  deverão AGUARDAR desconto na folha de pagamento, bem como contato do SESC através\n                  de SMS para efetivação do credenciamento no App Credencial Sesc SP, podendo baixar\n                  desde já):\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3326f377","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/credenciamento-sesc/index.vue
// module id = Tce3
// module chunks = 5